import React, { SVGProps } from "react";
import { ReactComponent as DefaultAvatarIcon } from "../assets/svgs/defaultAvatar.svg";

export const DefaultAvatar = (props: SVGProps<SVGSVGElement>) => {
  return <DefaultAvatarIcon {...props} />;
};
